import { ApiClientResponse, mediaModuleClient, routes } from '../../../common/services';
import { WebPageMetaDataDataObject } from '../../data-objects';

export const getMetadata = (url: string) => {
  return mediaModuleClient.get<WebPageMetaDataDataObject, ApiClientResponse<WebPageMetaDataDataObject>>(
    routes.chatrooms.media.getMetaData(url),
  );
};
